export const getIcon = (
  key: string,
  category: string,
  notFoundIcon: string
): NodeRequire | null => {
  let imgSrc = null;

  try {
    imgSrc = require(`../../../../assets/icons/${category}/${key}.svg`);
  } catch (e: any) {
    //@ts-ignore
    imgSrc = notFoundIcon;
  }
  return imgSrc;
};
